import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import * as api from '../../lib/api/api';
import * as PATH from '../../lib/routes/path';
import OrderLoading from '../../components/common/molecules/OrderLoading';
import moment from 'moment';
import { findEmojis, emojiRegex } from '../../lib/util/Emoji';
import { ERROR_REFRESH, ERROR_RETRY, STATUS_MESSAGE } from '../../lib/Error';
import { IMP_CODE, isPG } from '../../lib/PaymentInfo';
import PresentTemplate from '../../components/common/template/PresentTemplate';

const IMP = window.IMP; // 생략해도 괜찮습니다.
IMP.init(IMP_CODE); // "imp00000000" 대신 발급받은 "가맹점 식별코드"를 사용합니다.

class PresentContainer extends Component {
  state = {
    itemId: '',
    subItemId: '',
    optionIds: '',
    additionalOptionIds: '',
    subOptionIds: '',
    defaultPrice: 0,
    finalPrice: 0,
    defaultShippingFee: 0,
    email: '',
    name: '',
    mobile: '',
    recipientName: '',
    recipientMobile: '',
    recipientMessage: '',
    pay_method: 'card',
    merchant_uid: '',
    toCompletion: false,
    loading: false,
    pg: 'html5_inicis',
    voucherIds: [],
  };
  affiliateContext = this.props.affiliateContext;

  componentDidMount() {
    this.getBuyerInfo();
    this.getOrderInfo();
    this.checkStatus();
  }

  handleSelectVoucherCoupon = (voucherCouponList, onSetSelectedVoucherCoupon, setIsLoading) => {
    const itemId = sessionStorage.itemId;
    const optionIds = JSON.parse(sessionStorage.optionIds);

    if (setIsLoading) setIsLoading(true);
    api
      .tempPrice({
        itemId,
        voucherIds: voucherCouponList,
        optionIds,
        includeShippingFee: true,
      })
      .then((response) => {
        onSetSelectedVoucherCoupon(voucherCouponList);
        this.setState((prevState) => ({
          defaultPrice: response.data.defaultPrice,
          finalPrice: response.data.finalPrice,
          finalShippingFee: response.data.finalShippingFee,
          voucherIds: voucherCouponList,
        }));
      })
      .catch((error) => {
        const {
          status,
          data: { invalidValue },
        } = error.response;
        status === 400
          ? alert(invalidValue)
          : status === 409
          ? alert(STATUS_MESSAGE.order.testPrice[status])
          : alert(ERROR_REFRESH);
      }).finally(() => {
        if (setIsLoading) setIsLoading(false);
      });
  };

  getBuyerInfo = () => {
    const id = sessionStorage._id;
    api.getInfo({ id }).then((response) => {
      const tempMobile =
        response.data.contactInfo === null
          ? ''
          : response.data.contactInfo.mobile === null
          ? ''
          : response.data.contactInfo.mobile;
      this.setState({
        email: response.data.email,
        name: response.data.name,
        mobile: tempMobile,
      });
    });
  };

  getOrderInfo = () => {
    const voucherName = '베이비페이스 선물하기';
    const itemId = sessionStorage.itemId;
    const itemOptionIds = JSON.parse(sessionStorage.optionIds);

    api
      .postVoucherOrderTemplate({ voucherName, itemId, itemOptionIds })
      .then((response) => {
        this.setState(
          {
            subItemId: response.data.items[0].id,
            subOptionIds: response.data.items[0].optionIds,
          },
          () => {
            this.getPrice();
          },
        );
      });
  };

  getPrice = () => {
    const { subItemId, subOptionIds } = this.state;
    api.tempPresentPrice({ subItemId, subOptionIds }).then((response) => {
      this.setState({
        defaultPrice: response.data.defaultPrice,
        finalPrice: response.data.finalPrice,
        finalShippingFee: response.data.finalShippingFee,
      });
    });
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  checkStatus = () => {
    const message = STATUS_MESSAGE.order.requestPay.FAIL;
    if (this.props.status === 'true') {
      const merchant_uid = this.props.merchant_uid;
      const paymentKey = merchant_uid;
      this.setState({
        loading: true,
        merchant_uid: paymentKey,
      });
      let a = 0;
      const loop = () => {
        a += 1;
        api.getPaymentInfo(merchant_uid).then((response) => {
          if (
            response.data.status === 'PAID' ||
            response.data.status === 'PENDING_DEPOSIT'
          ) {
            this.affiliateContext.actions.setIsAffiliateOutlink(false);
            this.setState({
              toCompletion: true,
            });
            clearInterval(handler);
          }
        });
        if (a === 3) {
          clearInterval(handler);
          api.putForceRefund(paymentKey);
          alert(message);
          this.setState({
            loading: false,
          });
        }
      };
      const handler = setInterval(loop, 3000);
    } else if (this.props.status === 'false') {
      alert(`${message} 에러 내용: ${this.props.errorMSG}`);
    } else {
      return null;
    }
  };

  handleSubmit = async () => {
    const message = STATUS_MESSAGE.order;
    const presentMessage = message.present;
    if (
      this.state.name === '' ||
      this.state.mobile === '' ||
      this.state.recipientName === '' ||
      this.state.recipientMobile === ''
    ) {
      alert(presentMessage.REQUIRE_VALIDATION);
    } else {
      if (this.state.mobile === this.state.recipientMobile) {
        alert(message[409].ALREADY_EXISTS);
      } else if (findEmojis(this.state.recipientMessage)) {
        this.setState({
          recipientMessage: this.state.recipientMessage.replace(emojiRegex, ''),
        });
        alert(presentMessage.NO_EMOGI);
      } else {
        const {
          name,
          email,
          recipientName,
          recipientMessage,
          subItemId,
          subOptionIds,
          voucherIds,
        } = this.state;
        const paymentMethod =
          this.state.pay_method === 'card'
            ? 'CREDIT_CARD'
            : this.state.pay_method === 'vbank'
            ? 'VIRTUAL_ACCOUNT'
            : this.state.pg === 'kakaopay'
            ? 'KAKAO_PAY'
            : 'NONE';
        const mobile = this.state.mobile.replace(/[^0-9]/g, '');
        const recipientMobile = this.state.recipientMobile.replace(
          /[^0-9]/g,
          '',
        );
        this.setState({
          loading: true,
        });
    
        api
          .presentOrderSubmit({
            name,
            mobile,
            recipientMobile,
            recipientName,
            recipientMessage,
            subItemId,
            subOptionIds,
            email,
            paymentMethod,
            voucherIds,
          })
          .then((response) => {
            this.setState(
              {
                merchant_uid: response.data.paymentKey,
              },
              () => {
                // 크롬 팝업 차단 정책 대응: setTimeout을 사용하여 이벤트 루프의 다음 틱에서 실행
                // 사용자 제스처(클릭)를 보존하기 위해 즉시 실행
                setTimeout(() => {
                  this.requestPay();
                }, 0);
              },
            );
          })
          .catch((error) => {
            const { cause, message } = error.response.data;
            STATUS_MESSAGE.order[409][cause] !== undefined
              ? alert(STATUS_MESSAGE.order[409][cause])
              : alert(`${ERROR_RETRY}\n에러 메시지: ${message}`);
            this.setState({
              loading: false,
            });
          });
      }
    }
  };

  requestPay = () => {
    if (this.state.finalPrice === 0) {
      this.affiliateContext.actions.setIsAffiliateOutlink(false);
      this.setState({
        toCompletion: true,
      });
    } else {
      const mobile = this.state.mobile.replace(/[^0-9]/g, '');
      // 크롬 팝업 차단 정책 대응: 클릭 이벤트 내에서 즉시 호출
      // IMP.request_pay(param, callback) 호출
      try {
        IMP.request_pay(
          {
            // param
            pg: this.state.pg,
            pay_method: this.state.pay_method,
            merchant_uid: this.state.merchant_uid,
            name: '베이비페이스',
            amount: this.state.finalPrice,
            buyer_name: this.state.name,
            buyer_email: this.state.email,
            buyer_tel: mobile,
            notice_url: `${process.env.REACT_APP_BACKEND_URL}/any/payment/iamport`,
            m_redirect_url: `${process.env.REACT_APP_ORIGIN_URL}/present`,
            vbank_due: moment().clone().add(3, 'day').format('YYYYMMDDhhmm'),
          },
          (rsp) => {
            if (rsp.success) {
              const paymentKey = rsp.merchant_uid;
              let i = 0;
              const loop = () => {
                i += 1;
                api.getPaymentInfo(paymentKey).then((response) => {
                  if (
                    response.data.status === 'PAID' ||
                    response.data.status === 'PENDING_DEPOSIT'
                  ) {
                    this.affiliateContext.actions.setIsAffiliateOutlink(false);
                    this.setState({
                      toCompletion: true,
                    });
                    clearInterval(handler);
                  }
                });
                if (i === 7) {
                  clearInterval(handler);
                  api.putForceRefund(paymentKey);
                  alert(STATUS_MESSAGE.order.requestPay.FAIL);
                  this.setState({
                    loading: false,
                  });
                }
              };
              const handler = setInterval(loop, 3000);
            } else {
              alert(
                `${STATUS_MESSAGE.order.requestPay.FAIL} 에러 내용: ${rsp.error_msg}`,
              );
              this.setState({
                loading: false,
              });
            }
          },
        );
      } catch (error) {
        console.error('결제창 호출 오류:', error);
        alert(`${STATUS_MESSAGE.order.requestPay.FAIL} 결제창을 열 수 없습니다. 다시 시도해주세요.`);
        this.setState({
          loading: false,
        });
      }
    }
  };

  handlePayMethod = (e) => {
    const value = e.target.value;

    this.setState({
      pg: isPG(value) ? value : 'html5_inicis',
      pay_method: isPG(value) ? '' : value,
    });
  };

  render() {
    return (
      <>
        {this.state.toCompletion && (
          <Redirect to={`${PATH.COMPLETION}/${this.state.merchant_uid}`} />
        )}
        {this.state.loading ? (
          <OrderLoading />
        ) : (
          <PresentTemplate
            onChange={this.handleChange}
            onSubmit={this.handleSubmit}
            finalPrice={this.state.finalPrice}
            defaultPrice={this.state.defaultPrice}
            finalShippingFee={this.state.finalShippingFee}
            name={this.state.name}
            mobile={this.state.mobile}
            recipientMessage={this.state.recipientMessage}
            onPayMethod={this.handlePayMethod}
            pg={this.state.pg}
            pay_method={this.state.pay_method}
            onSelectVoucherCoupon={this.handleSelectVoucherCoupon}
          />
        )}
      </>
    );
  }
}

export default PresentContainer;
